module.exports = __webpack_public_path__ + "img/Tessellate11.691345a6.jpg";